import { types, flow, Instance, getRoot } from 'mobx-state-tree';

import { RouterState } from 'connected-react-router';
import { TagsPage as API } from '@src/services/companies';
import { ApiStore } from '@src/features/common';
import { toast } from 'src/components';

const Tag = types.model('Tag', {
  id: types.identifierNumber,
  name: types.string
});

export const TagsPageStore = types
  .compose(
    types.model('CareerPageStore', {
      data: types.array(Tag)
    }),
    ApiStore
  )

  .actions(self => {
    const fetchData = flow(function* fetch() {
      const res = yield self.fetch(
        API.getTagsBase(getRoot<{ routerStore: RouterState }>(self).routerStore.location.search)
      );
      self.data = res as any;
    });

    return {
      fetchData,
      onFetchSuccess: function (r) {
        !Array.isArray(r) && toast.info(r?.notice || r?.messages?.join?.(' ') || 'Success');
      },
      addTags: flow(function* fetch(tags: Array<string>) {
        yield self.post(API.getTagsBase(), {
          tags
        });

        fetchData();
      }),
      deleteTag: flow(function* fetch(id) {
        yield self.delete(API.getTegWithId(id));
        fetchData();
      }),
      editTag: flow(function* fetch(id, name) {
        yield self.patch(API.getTegWithId(id), {
          tag: { name }
        });
      })
    };
  });

export type ITagsStore = Instance<typeof TagsPageStore>;
export type ITag = Instance<typeof Tag>;
